import { HARDWARE_ID } from '../../utils/constants'
import { secureLocalStorage } from '../../utils/secureStorage'

export const userLogout = () => {
	const hardwareID = secureLocalStorage.getItem(HARDWARE_ID)
	localStorage.clear()
	secureLocalStorage.setItem(HARDWARE_ID, hardwareID)
	sessionStorage.clear()
}
